import { render, staticRenderFns } from "./CustomersTab.vue?vue&type=template&id=71226e00"
import script from "./CustomersTab.vue?vue&type=script&lang=js"
export * from "./CustomersTab.vue?vue&type=script&lang=js"
import style0 from "./CustomersTab.vue?vue&type=style&index=0&id=71226e00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports